import type { VendorCountryCode } from "../schemas";
import type { VendorRegion } from "../services/pim/types";
import type { CountryLocaleObject, Locale, RegionLocaleObject } from "../types/localization";

export const REGIONS_WITH_LOCALES: {
  [key in VendorRegion]: RegionLocaleObject[];
} = {
  BAU: [{ locale: "en_AU", name: "English", isDefault: true, isEnglish: true, emoji: "🇦🇺", flagCountryCode: "AU" }],
  BUK: [{ locale: "en_GB", name: "English", isDefault: true, isEnglish: true, emoji: "🇬🇧", flagCountryCode: "GB" }],
  BUS: [{ locale: "en_US", name: "English", isDefault: true, isEnglish: true, emoji: "🇺🇸", flagCountryCode: "US" }],
  BDE: [
    { locale: "de_DE", name: "German", isDefault: true, isEnglish: false, emoji: "🇩🇪", flagCountryCode: "DE" },
    { locale: "en_DE", name: "English", isDefault: false, isEnglish: true, emoji: "🇬🇧", flagCountryCode: "GB" },
    { locale: "nl_NL", name: "Dutch", isDefault: false, isEnglish: false, emoji: "🇳🇱", flagCountryCode: "NL" },
  ],
};

export const REGIONS_TO_COUNTRY_DEFAULT_LOCALE: { [key in VendorRegion]: string } = {
  BAU: "en_AU",
  BUS: "en_US",
  BUK: "en_GB",
  BDE: "de_DE",
};

export const DEFAULT_USER_LOCALE: Locale = "en_US";

export const VENDOR_KEY_REGEX: string = String.raw`^b[a-z]{2}:ven\d+$`;

// Batch creation limits
export const MAX_BATCH_SIZE = 2000;

export const COUNTRIES_WITH_LOCALES = {
  AU: [{ locale: "en_AU", name: "English", isDefault: true, isEnglish: true, flagCountryCode: "AU" }],
  GB: [{ locale: "en_GB", name: "English", isDefault: true, isEnglish: true, flagCountryCode: "GB" }],
  US: [{ locale: "en_US", name: "English", isDefault: true, isEnglish: true, flagCountryCode: "US" }],
  DE: [
    { locale: "de_DE", name: "German", isDefault: true, isEnglish: false, flagCountryCode: "DE" },
    { locale: "en_DE", name: "English", isDefault: false, isEnglish: true, flagCountryCode: "GB" },
  ],
  NL: [
    { locale: "nl_NL", name: "Dutch", isDefault: true, isEnglish: false, flagCountryCode: "NL" },
    { locale: "en_NL", name: "English", isDefault: false, isEnglish: true, flagCountryCode: "GB" },
  ],
} satisfies Record<VendorCountryCode, CountryLocaleObject[]>;
